import { PropsWithChildren } from 'react';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

const ToolbarContainer = styled(Flex)<{ compact?: boolean }>`
	> * {
		flex-grow: 0;
		flex-shrink: 0;
		margin: 0px ${(props) => (props.compact ? 4 : 10)}px;

		&:first-child {
			margin-left: 0px;
		}

		&:last-child {
			margin-right: 0px;
		}
	}
`;

export function Toolbar(props: PropsWithChildren<BoxProps & { compact?: boolean }>) {
	return <ToolbarContainer {...props} />;
}

Toolbar.Spacing = styled(Box)`
	flex-grow: 1 !important;
	flex-shrink: 1 !important;
`;
